module.exports = __webpack_public_path__ + "static/media/Screenshot 2026-03-13 at 04.04.34.0f46a5a6.png";